/** @format */

import { ReactNode } from 'react';
import { FacilityGroup } from 'sletat-api-services/lib/sletat/models/initial-state/page-models/hotel';
import { iconsFacility } from './iconsFacility';

export interface FacilityGroupIcon extends FacilityGroup {
    icon: ReactNode;
}

export const mergeIconHotelFacilities = (
    input: FacilityGroup[] | null
): FacilityGroupIcon[] | null =>
    input?.map(
        (e) =>
            ({
                ...iconsFacility.find((i) => i.id === e.id),
                ...e,
            } as FacilityGroupIcon)
    ) ?? null;
